import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpResponse } from '@angular/common/http';
import { of, Subject } from 'rxjs';
import { map } from 'rxjs/operators';
import { EditorCommonService } from 'src/app/product-journey-manager/editor/editor-common.service';
import { cloneDeep } from 'lodash';
@Injectable({
  providedIn: 'root'
})
export class JourneysService {
  private journeyWithDtree = null;
  private selectedAppId = null;
  private journeyDtreeFetchInProgress = false;
  private journeyWithDtreeReady = new Subject<any>();
  public onsiteJourneyData: any = {};

  constructor(private http: HttpClient, private editorCommonService: EditorCommonService) {
  }

  fetchAllJourneyFromNetwork(url) {
    return this.http.get<any>(url).pipe(
      map((res: Response) => {
        const body = res;
        return body || {};
      })
    );
  }

  /**
   *
   * @param params i.e. {appId: '', jId: ''}
   */
  getJourneys(appId, params?) {
    const url = '/dashboard/ujm/v1/' + appId;
    return this.http.get<any>(url, { 'params': params }).pipe(
      map((res: Response) => {
        const body = res;
        return body || {};
      })
    );
  }

  searchJourneys(appId, params?) {
    const url = '/dashboard/ujm/v1/search/' + appId;
    return this.http.get<any>(url, { 'params': params }).pipe(
      map((res: Response) => {
        const body = res;
        return body || {};
      })
    );
  }

  getJourneyDetail(appId, jId) {
    const url = '/dashboard/ujm/v1/' + appId + '/' + jId;
    return this.http.get<any>(url).pipe(
      map((res: Response) => {
        const body = res;
        return body || {};
      })
    );
  }

  upsertJourney(journeyData, update = false) {
    const url = `${update ? '/dashboard/ujm/v1/updateTimeAndDesc' : '/dashboard/ujm/v1'}`;
    return this.http.post<any>(url, journeyData).pipe(
      map((res: Response) => {
        const body = res;
        return body || {};
      })
    );
  }

  deleteJourney(aId, jId) {
    const _this = this;
    const url = '/dashboard/ujm/v1/' + aId + '/' + jId;
    return this.http.delete<any>(url).pipe(
      map((res: Response) => {
        const body = res;
        return body || {};
      })
    );
  }

  getEvents(appId, offset, limit) {
    const url = '/dashboard/event/v1/' + appId + '?o=' + offset + '&l=' + limit + '&t=0';
    return this.http.get<any>(url).pipe(
      map((res: Response) => {
        const body = res;
        return body || {};
      })
    );
  }

  attachEventToJourney(aId, jId, attachDetachModuleData) {
    const url = '/dashboard/module/v1/' + aId + '/' + jId;
    return this.http.post<any>(url, attachDetachModuleData).pipe(
      map((res: Response) => {
        const body = res;
        return body || {};
      })
    );
  }

  activateDetactivateUj(aId, jId, request_type) {
    const url = '/dashboard/ujm/v1/' + aId + '/' + jId + '/' + (request_type ? 'a' : 'd');
    return this.http.post<any>(url, {}).pipe(
      map((res: Response) => {
        const body = res;
        return body || {};
      })
    );
  }

  getPromptVariables(appId) {
    const url = '/dashboard/event/var/v1/' + appId;
    return this.http.get<any>(url).pipe(
      map((res: Response) => {
        const body = res;
        return body || {};
      })
    );
  }

  fakeResponse(dataName?) {
    return of((new HttpResponse({ status: 200, body: dataName })).body);
  }

  deletePreview(aId: string, jId: string) {
    // imap
    const url = '/dashboard/ujm/v1/' + aId + '/' + jId + '/' + 'preview/del';
    return this.http.post<any>(url, {}).pipe(
      map((res: Response) => {
        const body = res;
        return body || {};
      })
    );
  }

  deleteBranchPreview(aId: string, jId: string, payload: any) {
    // branch
    const url = '/dashboard/ujm/v1/' + aId + '/' + jId + '/' + 'preview/del';
    return this.http.post<any>(url, payload).pipe(
      map((res: Response) => {
        const body = res;
        return body || {};
      })
    );
  }

  getActivePreviews(aId: string, jId: string) {
    const url = '/dashboard/ujm/v1/' + aId + '/' + jId + '/' + 'preview/';
    return this.http.get<any>(url).pipe(
      map((res: Response) => {
        const body = res;
        return body || {};
      })
    );
  }

  addPreview(aId: string, jId: string, previewData: any) {
    const url = '/dashboard/ujm/v1/' + aId + '/' + jId + '/' + 'preview/';
    return this.http.post<any>(url, previewData).pipe(
      map((res: Response) => {
        const body = res;
        return body || {};
      })
    );
  }

  getNudgeCollectionByName(dtree) {
    if (dtree && dtree.statements) {
      const nudgeList = this.editorCommonService.getPromptsList(dtree.statements[0], []);
      return nudgeList.reduce((acc, nudge) => {
        acc[nudge.title] = nudge;
        return acc;
      }, {});
    }
    return {};
  }

  checkForDuplicateVariant(appId, nudgeName) {
    const url = `/dashboard/nudges/${appId}/uniquename?q=${nudgeName}`;
    return this.http.get<any>(url).pipe(
      map((res: Response) => {
        const body = res;
        return body || {};
      })
    );
  }

  getNudgeList(appId) {
    const url = `/dashboard/nudges/${appId}`;
    return this.http.get<any>(url).pipe(
      map((res: Response) => {
        const body = res;
        return body || {};
      })
    );
  }

  getNudgeObjectForJourney(appId, nudgeDetails) {
    return new Promise((resolve, reject) => {
      this.getJourneyDetail(appId, nudgeDetails.journeyId).subscribe((data: any) => {
        if (data && data.api_response) {
          const dtree = data.api_response.journey.dtree;
          const prompts = this.editorCommonService.getPromptsList(dtree.statements[0], []);
          // simulated nudge will be created if it's a part of AB branch compare nudge title and lidx
          // to get exact nudge object
          const nudge = prompts.filter((prompt: any) => prompt.title === nudgeDetails.name && prompt.lidx === nudgeDetails.id)[0];
          resolve(nudge);
        }
      });
    });
  }

  upsertVZData(payload) {
    const url = `/dashboard/nudges/vz_data/`;
    return this.http.post<any>(url, payload).pipe(
      map((res: Response) => {
        const body = res;
        return body || {};
      })
    );
  }

  fetchVZData(aid, jid, vz_data_id) {
    const url = `/dashboard/nudges/vz_data?aid=${aid}&jid=${jid}&vz_data_id=${vz_data_id}`;
    return this.http.get<any>(url).pipe(
      map((res: Response) => {
        const body = res;
        return body || {};
      })
    );
  }

  cancelJourneyChange(aid, jid) {
    const url = `/dashboard/ujm/v1/${aid}/${jid}/cancel`;
    return this.http.get<any>(url).pipe(
      map((res: Response) => {
        const body = res;
        return body || {};
      })
    );
  }

  upsertHTMLData(payload) {
    const url = `/dashboard/nudges/html/`;
    return this.http.post<any>(url, payload).pipe(
      map((res: Response) => {
        const body = res;
        return body || {};
      })
    );
  }

  putHTMLData(payload) {
    const url = `/dashboard/nudges/html/update`;
    return this.http.put<any>(url, payload).pipe(
      map((res: Response) => {
        const body = res;
        return body || {};
      })
    );
  }

  deleteZIPFile(aid, jid, uniqueId) {
    const url = `/dashboard/nudges/html/delete/${aid}/${jid}/${uniqueId}`;
    return this.http.delete<any>(url).pipe(
      map((res: Response) => {
        const body = res;
        return body || {};
      })
    );
  }

  fetchJourneys(appId) {
    const url = `/dashboard/ujm/v1/${appId}/journeys/live`;
    return this.http.get<any>(url).pipe(
      map((res: Response) => {
        const body = res;
        return body || {};
      })
    );
  }

  fetchJourneysReport(payload) {
    const headers = new HttpHeaders({
      Accept: 'text/csv',
      'Content-Type': 'text/csv'
    });
    const options = { headers, responseType: 'text' as any };
    const url = `/dashboard/smtanalytics/v1/aggregation/report/download`;
    return this.http.post(url, payload, options);
  }

  fetchCompanyNames() {
    const url = `/dashboard/company/names`;
    return this.http.get<any>(url).pipe(
      map((res: Response) => {
        const body = res;
        return body || {};
      })
    );
  }

  checkForDuplicateTemplate(templateName) {
    const url = `/dashboard/nudges/template/names/unique?name=${templateName}`;
    return this.http.get<any>(url).pipe(
      map((res: Response) => {
        const body = res;
        return body || {};
      })
    );
  }

  upsertNudgeTemplate(payload) {
    const url = `/dashboard/nudges/template`;
    return this.http.post<any>(url, payload).pipe(
      map((res: Response) => {
        const body = res;
        return body || {};
      })
    );
  }

  putNudgeTemplate(payload) {
    const url = `/dashboard/nudges/template`;
    return this.http.put<any>(url, payload).pipe(
      map((res: Response) => {
        const body = res;
        return body || {};
      })
    );
  }

  fetchTemplates(companyId, app) {
    const url = `/dashboard/nudges/template/${companyId}/${app}`;
    return this.http.get<any>(url).pipe(
      map((res: Response) => {
        const body = res;
        return body || {};
      })
    );
  }

  getFormattedTemplates(customTemplates, os) {
    const clonedData = cloneDeep(customTemplates);
    const templates = clonedData.map((template: any) => {
      const obj = template.nudgePayload[os];
      obj['templateData'] = {
        apps: template.apps,
        clientIds: template.clientIds,
        customTemplate: template.customTemplate,
        id: template.id,
        tag: template.tag,
        thumbnailUrl: template.thumbnailUrl
      };
      return obj;
    });
    return templates;
  }
}
